import axios from 'axios'
import store from './../../store/store'

export class Errors {
  /**
   * Create a new Errors instance.
   */
  constructor() {
    this.errors = {};
    this.error = {
      title: '',
      message: '',
      status: '',
    };
  }


  /**
   * Determine if an errors exists for the given field.
   *
   * @param {string} field
   */
  has(field) {
    return this.errors.hasOwnProperty(field);
  }


  /**
   * Determine if we have any errors.
   */
  any() {
    return Object.keys(this.errors).length > 0;
  }


  /**
   * Retrieve the error message for a field.
   *
   * @param {string} field
   */
  get(field) {
    if (this.errors[field]) {
      return this.errors[field][0];
    }
  }


  /**
   * Record the new errors.
   *
   * @param {object} errors
   */
  record(errors) {
    // alert(JSON.stringify(errors.status));

    this.error.status = errors.status;

    if(this.error.status === 422)
    {
      // This is for incorrect filled in forms
      this.error.message = errors.data.message; // The given data was invalid
      this.error.title = 'Validation Errors';
    }

    if(this.error.status === 450)
    {
      // This is for custom generated messages
      this.error.message = errors.data.message; // Custom messages
      this.error.title = 'Error';
    }

    if(this.error.status === 405)
    {
      // If incorrect method is posted for API call, Post/Put/Get/Destroy
      this.error.message = errors.statusText; // Method Not Allowed
      this.error.title = 'Invalid Method Called';
    }

    if(this.error.status === 401)
    {
      // If unauthorized user
      this.error.message = 'Unauthorized Request. Please Login.';
      this.error.title = 'Authorization Error';
      // store.dispatch('auth/logout');
    }

    if(this.error.status === 400)
    {
      // If invalid request to Oauth server, like login attempts
      this.error.message = 'Please check the details and try again.'; //errors.data.message;
      this.error.title = 'Invalid Details';
    }

    if(this.error.status === 429)
    {
      // If unauthorized user
      this.error.message = 'Please try again shortly as there have been too many requests in the last minute';
      this.error.title = 'Too Many Requests';
    }

    if(errors.data.errors) {this.errors = errors.data.errors;}

    // Status Code: 422
    // =================
    // Message 1 (errors.data.message: The given data was invalid)
    // Message 3 (errors.statusText: Unprocessable Entity)
    // Errors: True
    //
    // Status Code: 450
    // =================
    // Message 1 (errors.data.message: Custom Messages)
    // Message 3 (errors.statusText: Unknown Status)
    // Errors: False
    //
    // Status Code: 405
    // =================
    // Message 3 (errors.statusText: Method Not Allowed)
    // Errors: False
    //
    // Status Code: 401
    // =================
    // Message 1: (errors.data.message: Unauthenticated)
    // Message 3 (errors.statusText: Unauthorized)
    // Errors: False
  }


  /**
   * Clear one or all error fields.
   *
   * @param {string|null} field
   */
  clear(field) {
    if (field) {
      delete this.errors[field];

      return;
    }

    this.errors = {};
  }
}

export class Form {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   */
  constructor(data) {
    this.originalData = data;

    for (let field in data) {
      this[field] = data[field];
    }

    this.errors = new Errors();
  }


  /**
   * Fetch all relevant data for the form.
   */
  data() {
    let data = {};

    for (let property in this.originalData) {
      data[property] = this[property];
    }

    return data;
  }


  /**
   * Reset the form fields.
   */
  reset() {
    for (let field in this.originalData) {
      this[field] = '';
    }

    this.errors.clear();
  }


  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   */
  post(url) {
    return this.submit('post', url);
  }


  /**
   * Send a PUT request to the given URL.
   * .
   * @param {string} url
   */
  put(url) {
    return this.submit('put', url);
  }


  /**
   * Send a PATCH request to the given URL.
   * .
   * @param {string} url
   */
  patch(url) {
    return this.submit('patch', url);
  }


  /**
   * Send a DELETE request to the given URL.
   * .
   * @param {string} url
   */
  delete(url) {
    return this.submit('delete', url);
  }


  /**
   * Submit the form.
   *
   * @param {string} requestType
   * @param {string} url
   */
  submit(requestType, url) {
    return new Promise((resolve, reject) => {
      axios[requestType](url, this.data())
        .then(response => {
          this.onSuccess(response.data);
          resolve(response.data);
        })
        .catch(error => {
          this.onFail(error.response);
          reject(error.response);
        });
    });
  }


  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
  onSuccess(data) {
    // alert(data.message); // temporary
    this.reset();
  }


  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    this.errors.record(errors);
  }
}


// WEBPACK FOOTER //
// ./src/components/validations/forms.js